import React from 'react';

export default function Card({
  children,
  title,
  headerActions,
  padding = 'p-6',
  className = '',
  ...props
}) {
  return (
    <div
      className={`${padding} ${className}`}
      style={{
        background: 'rgba(255,255,255,0.70)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderRadius: '24px',
        border: '1px solid rgba(255,255,255,0.28)',
        boxShadow: '0 8px 32px rgba(0,104,183,0.08)',
      }}
      {...props}
    >
      {(title || headerActions) && (
        <div className="flex items-center justify-between mb-4">
          {title && (
            <h3
              style={{
                fontSize: 18, fontWeight: 700, color: '#191c21',
                fontFamily: "'Space Grotesk', sans-serif",
                letterSpacing: '-0.3px', margin: 0,
              }}
            >
              {title}
            </h3>
          )}
          {headerActions && (
            <div className="flex items-center gap-2">{headerActions}</div>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
